/**
 * Berechnet die günstigsten Preise für digitale und Druckfotoboxen
 */
export async function getMinPrices() {
  try {
    const response = await fetch("/api/data?locale=de");
    const data = await response.json();

    let minDigitalPrice = null;
    let minPrintPrice = null;

    // Durchsuche alle Photobooths
    data.Photobooths?.forEach((booth) => {
      const basePrice = booth.PhotoboothPrice || 0;

      booth.Packages?.forEach((pkg) => {
        const totalPrice = basePrice + (pkg.PackagePrice || 0);

        // Digital (Print: false)
        if (pkg.Print === false) {
          if (minDigitalPrice === null || totalPrice < minDigitalPrice) {
            minDigitalPrice = totalPrice;
          }
        }

        // Mit Druck (Print: true)
        if (pkg.Print === true) {
          if (minPrintPrice === null || totalPrice < minPrintPrice) {
            minPrintPrice = totalPrice;
          }
        }
      });
    });

    return {
      minDigitalPrice,
      minPrintPrice,
    };
  } catch (error) {
    console.error("Fehler beim Laden der minimalen Preise:", error);
    return {
      minDigitalPrice: null,
      minPrintPrice: null,
    };
  }
}

/**
 * Formatiert einen Preis für die Anzeige
 */
export function formatPrice(price) {
  if (price === null || price === undefined) return "auf Anfrage";
  return `${price}€`;
}
